import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import {TextField,
        Grid,
        InputAdornment,
        NativeSelect,
        InputLabel,
        FormControl,
        Box,
        Switch,
        Typography
} from "@material-ui/core";
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PhoneIcon from '@material-ui/icons/Phone';
import SmartphoneIcon from '@material-ui/icons/Smartphone';
import EmailIcon from '@material-ui/icons/Email';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
//import CommentIcon from '@material-ui/icons/Comment';
//import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';

import enNZ from 'date-fns/locale/en-NZ'
import DatePicker, { registerLocale } from "react-datepicker";
import useStyles from './styles';
import classnames from "classnames";
import ttAPI from '../../api/ttAPI';
import Widget from '../../components/Widget';
import { useUserState } from "../../context/UserContext";
import AddressAutoComplete from '../../components/AddressAutoComplete/AddressAutoComplete';
//import SelectCustomerServices from './SelectCustomerServices';
import SelectCustomerTestingScopes from './SelectCustomerTestingScopes';
import CustomProperties from '../CustomProperties/CustomProperties';
import { sendNotification } from "../../context/UserContext";
import './Pricing.css'
import './Industry.css'
import './SelectCustomerTestingScopes.css'
import "react-datepicker/dist/react-datepicker.css";

registerLocale('en-NZ', enNZ);

const CreateCustomer = forwardRef((props, ref) => {
//export default function CreateCustomer(props, ref) {
    // global
    const { onFormUpdated, onCustomerUpdated, onCustomerCreated } = props
    var { hourly_charge } = useUserState(); // default hourly charge
    const classes = useStyles();
    const formRef = useRef(null);
    const [newCustomer, setNewCustomer] = useState({...props.createdCustomer});
    //const selectCustomerServicesRef = useRef(null);
    const selectCustomerTestingScopesRef = useRef(null);
    const [selectedChargeBy, setSelectedChargeBy] = useState('Tag');

    const [selectedAgreementStartDate, setSelectedAgreementStartDate] = React.useState();
    const [selectedAgreementEndDate, setSelectedAgreementEndDate] = React.useState();
    const [selectedPriceChangeDate, setSelectedPriceChangeDate] = React.useState(new Date());

    const agreementStartDateRef = useRef(null);
    const agreementStartDateCalendarRef = useRef(null);
    var currentAgreementStartDateValue = null;
    const [agreementStartDateFocused, setAgreementStartDateFocused] = React.useState(false);

    const agreementEndDateRef = useRef(null);
    const agreementEndDateCalendarRef = useRef(null);
    var currentAgreementEndDateValue = null;
    const [agreementEndDateFocused, setAgreementEndDateFocused] = React.useState(false);

    const priceChangeDateRef = useRef(null);
    const priceChangeDateCalendarRef = useRef(null);
    var currentPriceChangeDateValue = null;
    const [priceChangeDateFocused, setPriceChangeDateFocused] = React.useState(false);

    const [industryCategories, setIndustryCategories] = useState([]);

    useImperativeHandle(ref, () => ({

      saveCustomer() {
        formRef.current.dispatchEvent(new Event('submit'))
      }

    }));

    useEffect(() => {
      async function loadIndustryCategories() {
        const response = await ttAPI.getIndustryCategories();
        setIndustryCategories(response || []);
      }

      loadIndustryCategories();
    }, []);

    useEffect(() => {
      if (agreementStartDateCalendarRef !== undefined && agreementStartDateCalendarRef !== null &&
        agreementStartDateCalendarRef.current !== undefined && agreementStartDateCalendarRef.current !== null) {
        agreementStartDateCalendarRef.current.setOpen(agreementStartDateFocused);
      }
    },[agreementStartDateFocused]);

    useEffect(() => {
      if (agreementEndDateCalendarRef !== undefined && agreementEndDateCalendarRef !== null &&
        agreementEndDateCalendarRef.current !== undefined && agreementEndDateCalendarRef.current !== null) {
        agreementEndDateCalendarRef.current.setOpen(agreementEndDateFocused);
      }
    },[agreementEndDateFocused]);

    useEffect(() => {
      if (priceChangeDateCalendarRef !== undefined && priceChangeDateCalendarRef !== null &&
        priceChangeDateCalendarRef.current !== undefined && priceChangeDateCalendarRef.current !== null) {
        priceChangeDateCalendarRef.current.setOpen(priceChangeDateFocused);
      }
    },[priceChangeDateFocused]);

     useEffect(() => {
       if (newCustomer !== undefined && newCustomer !== null) {
         if (newCustomer.name === undefined || newCustomer.name === null || newCustomer.name === '' ||
            ((newCustomer.service_level_agreement ?? false) && (newCustomer.agreement_start_date === undefined || newCustomer.agreement_start_date === null || newCustomer.agreement_start_date === '')) ||
            ((newCustomer.service_level_agreement ?? false) && (newCustomer.agreement_end_date === undefined || newCustomer.agreement_end_date === null || newCustomer.agreement_end_date === '')) ||
            (newCustomer.testing_scopes === undefined || newCustomer.testing_scopes === null || newCustomer.testing_scopes.length <= 0) ||
            (newCustomer.testing_scopes !== undefined && newCustomer.testing_scopes !== null && newCustomer.testing_scopes.length > 0 &&
             ((newCustomer.testing_scopes.find(item => item !== undefined && item !== null && (item.name !== undefined && item.name !== null && item.name.toLowerCase().includes('please make a note'))) !== undefined) &&
             (newCustomer.testing_scope_other_notes== undefined || newCustomer.testing_scope_other_notes === null || newCustomer.testing_scope_other_notes === '')))) {
            onFormUpdated(false);
         }
         else {
           onFormUpdated(true);
         }
         onCustomerUpdated(newCustomer);

         // this will be triggered everytime customer properties changes, and since hourly_charge is not null, it always fall
         // into the first condition, instead - I set the hourly rate on changing the tag/hour selection
         /*if (newCustomer.hourly_charge !== null && newCustomer.hourly_charge !== undefined && newCustomer.hourly_charge > 0) {
             console.log("1");
             setSelectedChargeBy('Hour');
         }
         else {
             setSelectedChargeBy('Tag');
             console.log("2");
         }*/

         if (newCustomer.agreement_start_date !== undefined && newCustomer.agreement_start_date !== null && newCustomer.agreement_start_date !== '') {
               var d1 = new Date(newCustomer.agreement_start_date);
               setSelectedAgreementStartDate(d1);
         }

         if (newCustomer.agreement_end_date !== undefined && newCustomer.agreement_end_date !== null && newCustomer.agreement_end_date !== '') {
               var d1 = new Date(newCustomer.agreement_end_date);
               setSelectedAgreementEndDate(d1);
         }

         if (newCustomer.price_change_date !== undefined && newCustomer.price_change_date !== null && newCustomer.price_change_date !== '') {
               var d1 = new Date(newCustomer.price_change_date);
               setSelectedPriceChangeDate(d1);
         }

       }
     }, [newCustomer]);



   function handleChange(e) {
     setNewCustomer({
       ...newCustomer,
       [e.target.name]: e.target.value,
     });
   }

  async function handleSubmit (e) {
       const errors = validate(newCustomer.name);
       if (errors.length > 0) {
         console.error('create customer has error');
         return;
       }

       var customerToSave = newCustomer;
       /*if (customerToSave.services !== undefined && customerToSave.services !== null) {
          customerToSave.services = customerToSave.services.map(service => service.id);
       }*/
       if (customerToSave.testing_scopes !== undefined && customerToSave.testing_scopes !== null) {
          customerToSave.testing_scopes = customerToSave.testing_scopes.map(testing_scope => isNaN(testing_scope) ? testing_scope.id : testing_scope);
       }
       // customerToSave.hourly_charge value handled on selecting the tag/hour
       if (selectedChargeBy === 'Tag') {
           customerToSave.hourly_charge = 0;
       }
       else {
           if (customerToSave.hourly_charge === null || customerToSave.hourly_charge === undefined || customerToSave.hourly_charge <= 0) {
               customerToSave.hourly_charge = hourly_charge;
           }
       }

       if (customerToSave.service_level_agreement === null || customerToSave.service_level_agreement === undefined || !customerToSave.service_level_agreement) {
           customerToSave.agreement_start_date = null;
           customerToSave.agreement_end_date = null;
       }

       if (customerToSave.industry_category_id === '') {
          customerToSave.industry_category_id = null;
        }

        if (customerToSave.target_tag_rate_per_hour === '') {
          customerToSave.target_tag_rate_per_hour = null;
        }


       const response = await ttAPI.saveCustomer(customerToSave);

       if (response !== undefined && response.data !== undefined &&
           response.data[0] !== undefined) {
             if (response.data[0].ok) {
               setNewCustomer({
                 ...customerToSave,
                 id: response.data[0].id,
               });;
               onCustomerCreated(newCustomer, newCustomer.id > 0, response.data[0].id);
             }
             else {
               sendNotification('error', newCustomer.id > 0 ?  'Failed to update customer.' : 'Failed to create customer.', classes);
             }
       }
   }

    function validate(name) {
      const errors = [];
      if (name === undefined || name === null || name === '') {
        setNewCustomer({
          ...newCustomer,
          name: '',
        });
          errors.push("Name can't be empty");
        }
        return errors;
    }

   function onSelectCustomerAddress(address) {
     setNewCustomer({
       ...newCustomer,
       address: address
     });
   }

   function onGeoLocationFetched(geolocation) {
     setNewCustomer({
       ...newCustomer,
       mapurl: `https://maps.google.co.nz/maps?q=${geolocation.lat},${geolocation.lng}`
     });
   }

   function onClickAutoFailedReportSwitch() {
       setNewCustomer({
         ...newCustomer,
         auto_failed_report: newCustomer.auto_failed_report === undefined || newCustomer.auto_failed_report === null ? false : !newCustomer.auto_failed_report
       });
   }

   /*function onServicesSelected(services) {
       setNewCustomer({
         ...newCustomer,
         services: services,
       });
   }*/

   function onTestingScopesSelected(testingScopes) {
       setNewCustomer({
         ...newCustomer,
         testing_scopes: testingScopes,
       });
   }

   function onOtherTestingScopesSpecified(otherTestingScopeNotes) {
     setNewCustomer({
       ...newCustomer,
       testing_scope_other_notes: otherTestingScopeNotes,
     });
   }

   function onCustomerPropertiesChanged(customProperties) {
     setNewCustomer({
       ...newCustomer,
       custom_properties: customProperties,
     });
   }

   function onCustomPropertiesEnableChanged(customPropertiesEnabled) {
     setNewCustomer({
       ...newCustomer,
       enable_custom_properties: customPropertiesEnabled,
     });
   }

   function handleChangeSelectChargeBy(e) {
       setSelectedChargeBy(e.target.value);
       setNewCustomer({
         ...newCustomer,
         hourly_charge: e.target.value === 'Tag' ? 0 : hourly_charge
       });
   }

   function onClickRequireVaccinationProofSwitch() {
       setNewCustomer({
         ...newCustomer,
         require_vaccination_proof: newCustomer.require_vaccination_proof === undefined || newCustomer.require_vaccination_proof === null ? false : !newCustomer.require_vaccination_proof
       });
   }

   function onClickPoRequiredSwitch() {
       setNewCustomer({
         ...newCustomer,
         po_required: newCustomer.po_required === undefined || newCustomer.po_required === null ? false : !newCustomer.po_required
       });
   }

   function onClickJSARequiredSwitch() {
       setNewCustomer({
         ...newCustomer,
         jsa_required: newCustomer.jsa_required === undefined || newCustomer.jsa_required === null ? false : !newCustomer.jsa_required
       });
   }

   function onClickMicrowaveOnlySwitch() {
       setNewCustomer({
         ...newCustomer,
         microwave_only: newCustomer.microwave_only === undefined || newCustomer.microwave_only === null ? false : !newCustomer.microwave_only
       });
   }

   function onClickServiceLevelAgreementSwitch() {
       setNewCustomer({
         ...newCustomer,
         service_level_agreement: !(newCustomer.service_level_agreement ?? false)
       });
   }

   // triggered if value changes, but not save anywhere as the value here can be in-progress (if use keyboard)
   function handleChangeAgreementStartDate(d) {
     currentAgreementStartDateValue = d;
   }

   function handleChangeAgreementEndDate(d) {
     currentAgreementEndDateValue = d;
   }

   function handleChangePriceChangeDate(d) {
     currentPriceChangeDateValue = d;
   }

   function focusAgreementStartDate(event) {
     setAgreementStartDateFocused(true);
   }

   function focusAgreementEndDate(event) {
     setAgreementEndDateFocused(true);
   }

   function focusPriceChangeDate(event) {
     setPriceChangeDateFocused(true);
   }

   function blurAgreementStartDate(event) {
     setAgreementStartDateFocused(false);
     saveAgreementStartDate();
   }

   function blurAgreementEndDate(event) {
     setAgreementEndDateFocused(false);
     saveAgreementEndDate();
   }

   function blurPriceChangeDate(event) {
     setPriceChangeDateFocused(false);
     savePriceChangeDate();
   }

   // triggered if use keyboard
   function handleAgreementStartDateKeyPress(event) {
     if (event.which === 9 || event.which === 13 || event.which === 27) {
       setAgreementStartDateFocused(false);
       saveAgreementStartDate();
     }
   }

   function handleAgreementEndDateKeyPress(event) {
     if (event.which === 9 || event.which === 13 || event.which === 27) {
       setAgreementEndDateFocused(false);
       saveAgreementEndDate();
     }
   }

   function handlePriceChangeDateKeyPress(event) {
     if (event.which === 9 || event.which === 13 || event.which === 27) {
       setPriceChangeDateFocused(false);
       savePriceChangeDate();
     }
   }

   // triggered if select a date
   function handleSelectAgreementStartDate(d) {
     saveAgreementStartDate();
   }

   function handleSelectAgreementEndDate(d) {
     saveAgreementEndDate();
   }

   function handleSelectPriceChangeDate(d) {
     savePriceChangeDate();
   }

   function saveAgreementStartDate() {
     var d = currentAgreementStartDateValue !== undefined && currentAgreementStartDateValue !== null ? new Date(currentAgreementStartDateValue) : null;
     if (d !== null) {
       let [date, month, year] = d.toLocaleDateString('en-NZ').split("/");
       setNewCustomer({
         ...newCustomer,
         agreement_start_date: `${year}-${month}-${date}`,
       });

       setSelectedAgreementStartDate(new Date(currentAgreementStartDateValue));
       currentAgreementStartDateValue = d;
     }
   }

   function saveAgreementEndDate() {
     var d = currentAgreementEndDateValue !== undefined && currentAgreementEndDateValue !== null ? new Date(currentAgreementEndDateValue) : null;
     if (d !== null) {
       let [date, month, year] = d.toLocaleDateString('en-NZ').split("/");
       setNewCustomer({
         ...newCustomer,
         agreement_end_date: `${year}-${month}-${date}`,
       });
       setSelectedAgreementEndDate(new Date(currentAgreementEndDateValue));
       currentAgreementEndDateValue = d;
     }
   }

   function savePriceChangeDate() {
     var d = currentPriceChangeDateValue !== undefined && currentPriceChangeDateValue !== null ? new Date(currentPriceChangeDateValue) : null;
     if (d !== null) {
       let [date, month, year] = d.toLocaleDateString('en-NZ').split("/");
       setNewCustomer({
         ...newCustomer,
         price_change_date: `${year}-${month}-${date}`,
       });
       setSelectedPriceChangeDate(new Date(currentPriceChangeDateValue));
       currentPriceChangeDateValue = d;
     }
   }



  return (
    <div className={classes.contentDiv}>
    {/*}<div>{`props.createdCustomer is ${props.createdCustomer}`}</div>
    <div>{`props.createdCustomer.name is ${props.createdCustomer.name}`}</div>
    <div>{`props.createdCustomer.id is ${props.createdCustomer.id}`}</div>
    <div>{`newCustomer is ${newCustomer}`}</div>
    <div>{`newCustomer.name is ${newCustomer.name}`}</div>
    <div>{`newCustomer.id is ${newCustomer.id}`}</div>*/}
    <form
        ref={formRef}
        onSubmit={handleSubmit}>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6} sm={6}>

              <Widget
                title="Company Details"
                upperTitle
                disableWidgetMenu
                showOverflow
              >
                <div className={classes.formDisplay}>
                <TextField
                  id="name"
                  label="Name"
                  autoComplete='off'
                  onChange={handleChange}
                  name="name"
                  value={newCustomer.name || ''}
                  variant="outlined"
                  required
                  error={newCustomer.name === ''}
                  helperText={newCustomer.name === '' ? 'Please enter the name of the customer.' : ' '}
                  size="small"
                />
                  <TextField
                    id="company"
                    label="Company"
                    autoComplete='off'
                    onChange={handleChange}
                    name="company"
                    value={newCustomer.company || ''}
                    variant="outlined"
                    style={{ marginBottom: 20 }}
                    size="small"
                  />

                  <FormControl
                    variant="outlined"
                    style={{ marginBottom: 20 }}
                    className={classnames({
                          'industrySelect':  true,
                          'industry-select-control': true
                        })}
                  >
                    <InputLabel shrink>Industry Category</InputLabel>
                    <div className={classnames({
                                  'industry-select-control-input': true
                                })}>
                    <NativeSelect
                      value={newCustomer.industry_category_id || ''}
                      onChange={handleChange}
                      name="industry_category_id"
                    >
                      <option value=""></option>
                      {industryCategories.map(category => (
                        <option key={category.id} value={category.id}>
                          {category.name}
                        </option>
                      ))}
                    </NativeSelect>
                    </div>
                  </FormControl>

                  <TextField
                    id="targetTagRatePerHour"
                    label="Target Tag Rate / Hour"
                    autoComplete="off"
                    onChange={handleChange}
                    name="target_tag_rate_per_hour"
                    value={newCustomer.target_tag_rate_per_hour || ''}
                    variant="outlined"
                    style={{ marginBottom: 20 }}
                    type="number"
                    size="small"
                  />

                  <AddressAutoComplete onSelect={onSelectCustomerAddress} onLocationUpdate={onGeoLocationFetched}/>


                  <TextField
                    id="notes"
                    name="notes"
                    label="Notes"
                    autoComplete='off'
                    value={newCustomer.notes || ''}
                    multiline
                    rows="5"
                    variant="outlined"
                    onChange={handleChange}
                    style={{ marginBottom: 20 }}
                    size="small"
                    InputProps={{
                      className: classes.textarea,
                    }}
                  />

                  <TextField
                    id="booking_instructions"
                    name="booking_instructions"
                    label="Booking Instructions"
                    autoComplete='off'
                    value={newCustomer.booking_instructions || ''}
                    multiline
                    rows="10"
                    variant="outlined"
                    onChange={handleChange}
                    style={{ marginBottom: 20 }}
                    size="small"
                    InputProps={{
                      className: classes.textarea,
                    }}
                  />

                  {/*<SelectCustomerServices ref={selectCustomerServicesRef}
                                     isAddCustomer={true}
                                     customer={newCustomer}
                                     onServicesSelected={onServicesSelected}/>*/}

                  <SelectCustomerTestingScopes ref={selectCustomerTestingScopesRef}
                                    required={true}
                                    isAddCustomer={true}
                                    customer={newCustomer}
                                    onTestingScopesSelected={onTestingScopesSelected}
                                    onOtherTestingScopesSpecified={onOtherTestingScopesSpecified}/>

                  <Box display={"flex"} alignItems={"center"}>
                      <Typography weight={"medium"}>
                          PO Required
                      </Typography>
                      <Switch color={"primary"} checked={newCustomer.po_required || false}
                              onClick={onClickPoRequiredSwitch} />
                  </Box>

                  <Box display={"flex"} alignItems={"center"}>
                      <Typography weight={"medium"}>
                          JSA Required
                      </Typography>
                      <Switch color={"primary"} checked={newCustomer.jsa_required || false}
                              onClick={onClickJSARequiredSwitch} />
                  </Box>

                  <Box display={"flex"} alignItems={"center"}>
                      <Typography weight={"medium"}>
                          No Microwave LKG
                      </Typography>
                      <Switch color={"primary"} checked={newCustomer.microwave_only || false}
                              onClick={onClickMicrowaveOnlySwitch} />
                  </Box>

                  <div className={classnames({
                                  [classes.section]: newCustomer !== null && newCustomer !== undefined && (newCustomer.service_level_agreement || false)
                                  })}>
                    <Box display={"flex"} alignItems={"center"}>
                        <Typography weight={"medium"}>
                            Service Level Agreement
                        </Typography>
                        <Switch color={"primary"} checked={newCustomer.service_level_agreement || false}
                                onClick={onClickServiceLevelAgreementSwitch} />
                    </Box>
                    { newCustomer !== null && newCustomer !== undefined && (newCustomer.service_level_agreement || false)  &&
                      <div className={classes.calendars} style={{ marginBottom: 20 }}>
                      <TextField
                        id="agreementStartDate"
                        ref={agreementStartDateRef}
                        style={{ marginTop: 10}}
                        label="Agreement Start Date"
                        required
                        className={classnames({
                        'textField': true,
                        'calenderField': true,
                        [classes.calendarFocused]: agreementStartDateFocused,
                        [classes.error]: selectedAgreementStartDate === null
                      })}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          startAdornment: (
                              <InputAdornment position="start">
                                <CalendarTodayIcon />
                              </InputAdornment>
                            ),
                            inputComponent: () =>
                            <DatePicker
                            ref={agreementStartDateCalendarRef}
                            className={classes.textField}
                            selected={selectedAgreementStartDate}
                            onSelect={handleSelectAgreementStartDate}
                            onChange={handleChangeAgreementStartDate}
                            onFocus={focusAgreementStartDate}
                            onClickOutside={blurAgreementStartDate}
                            onKeyDown={handleAgreementStartDateKeyPress}
                            locale="en-NZ"
                            dateFormat="dd/MM/yyyy"
                            />
                          }}
                          />

                          <TextField
                            id="agreementEndDate"
                            ref={agreementEndDateRef}
                            style={{ marginTop: 10}}
                            label="Agreement End Date"
                            required
                            className={classnames({
                            'textField': true,
                            'calenderField': true,
                            [classes.calendarFocused]: agreementEndDateFocused,
                            [classes.error]: selectedAgreementEndDate === null
                          })}
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              startAdornment: (
                                  <InputAdornment position="start">
                                    <CalendarTodayIcon />
                                  </InputAdornment>
                                ),
                                inputComponent: () =>
                                <DatePicker
                                ref={agreementEndDateCalendarRef}
                                className={classes.textField}
                                selected={selectedAgreementEndDate}
                                onSelect={handleSelectAgreementEndDate}
                                onChange={handleChangeAgreementEndDate}
                                onFocus={focusAgreementEndDate}
                                onClickOutside={blurAgreementEndDate}
                                onKeyDown={handleAgreementEndDateKeyPress}
                                locale="en-NZ"
                                dateFormat="dd/MM/yyyy"
                                />
                              }}
                              />

                          </div>
                    }
                  </div>

                  { newCustomer !== null && newCustomer !== undefined &&
                  <div>
                      <TextField
                        id="priceChangeDate"
                        ref={priceChangeDateRef}
                        label="Price Change Date"
                        style={{ marginBottom: 20 }}
                        className={classnames({
                        'textField': true,
                        'calenderField': true,
                        [classes.calendarFocused]: priceChangeDateFocused,
                        [classes.error]: selectedPriceChangeDate === null
                      })}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          startAdornment: (
                              <InputAdornment position="start">
                                <CalendarTodayIcon />
                              </InputAdornment>
                            ),
                            inputComponent: () =>
                            <DatePicker
                            ref={priceChangeDateCalendarRef}
                            className={classes.textField}
                            selected={selectedPriceChangeDate}
                            onSelect={handleSelectPriceChangeDate}
                            onChange={handleChangePriceChangeDate}
                            onFocus={focusPriceChangeDate}
                            onClickOutside={blurPriceChangeDate}
                            onKeyDown={handlePriceChangeDateKeyPress}
                            locale="en-NZ"
                            dateFormat="dd/MM/yyyy"
                            />
                          }}
                          />
                  </div>
                  }

                </div>
            </Widget>

          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <Widget
              title="Contact"
              upperTitle
              disableWidgetMenu
              noMinHeight
            >
              <div className={classes.formDisplay}>
                <TextField
                  id="contact"
                  label="Contact"
                  autoComplete='off'
                  onChange={handleChange}
                  name="contact"
                  value={newCustomer.contact || ''}
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AssignmentIndIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="phone"
                  label="Phone"
                  autoComplete='off'
                  onChange={handleChange}
                  name="phone"
                  value={newCustomer.phone || ''}
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="mobile"
                  label="Mobile"
                  onChange={handleChange}
                  name="mobile"
                  autoComplete='off'
                  value={newCustomer.mobile || ''}
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SmartphoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  id="email"
                  label="Email"
                  autoComplete='off'
                  onChange={handleChange}
                  value={newCustomer.email || ''}
                  name="email"
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  type={'email'}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="repairEmail"
                  label="Repair Email"
                  autoComplete='off'
                  onChange={handleChange}
                  value={newCustomer.repair_email || ''}
                  name="repair_email"
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  type={'email'}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="healthSafetyEmail"
                  label="Health & Safety Contact Email"
                  autoComplete='off'
                  onChange={handleChange}
                  value={newCustomer.health_safety_email || ''}
                  name="health_safety_email"
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  type={'email'}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />


              </div>
            </Widget>

            <Widget
              title="Billing Contact"
              upperTitle
              disableWidgetMenu
              noMinHeight
              style={{marginTop:'20px'}}
            >
              <div className={classes.formDisplay}>
                <TextField
                  id="billing_contact"
                  label="Billing Contact"
                  autoComplete='off'
                  onChange={handleChange}
                  name="billing_contact"
                  value={newCustomer.billing_contact || ''}
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AssignmentIndIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="biling_phone"
                  label="Billing Phone"
                  autoComplete='off'
                  onChange={handleChange}
                  name="billing_phone"
                  value={newCustomer.billing_phone || ''}
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="billing_mobile"
                  label="Billing Mobile"
                  onChange={handleChange}
                  name="billing_mobile"
                  autoComplete='off'
                  value={newCustomer.billing_mobile || ''}
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SmartphoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  id="billing_email"
                  label="Billing Email"
                  autoComplete='off'
                  onChange={handleChange}
                  value={newCustomer.billing_email || ''}
                  name="billing_email"
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  type={'email'}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />

              </div>
            </Widget>
            <Widget
              title="Failed Report"
              upperTitle
              disableWidgetMenu
              noMinHeight
              style={{marginTop:'20px'}}
            >
                <Box display={"flex"} alignItems={"center"}>
                    <Typography weight={"medium"}>
                        Auto Failed Report
                    </Typography>
                    <Switch color={"primary"} checked={newCustomer.auto_failed_report}
                            onClick={onClickAutoFailedReportSwitch} />
                </Box>

                <TextField
                  id="failed_report_email"
                  label="Failed Report Email"
                  autoComplete='off'
                  onChange={handleChange}
                  value={newCustomer.failed_report_email || ''}
                  name="failed_report_email"
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  type={'email'}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />

            </Widget>
            {/*<Widget
              title="Vaccination"
              style={{marginTop:'20px'}}
              upperTitle
              disableWidgetMenu
              noMinHeight>
                  <Box display={"flex"} alignItems={"center"}>
                      <Typography weight={"medium"}>
                          Proof of vaccination required
                      </Typography>
                      <Switch color={"primary"} checked={newCustomer.require_vaccination_proof || false}
                              onClick={onClickRequireVaccinationProofSwitch} />
                  </Box>

                  <TextField
                    id="covid_policy"
                    name="covid_policy"
                    label="COVID Policy"
                    autoComplete='off'
                    value={newCustomer.covid_policy || ''}
                    multiline
                    rows="10"
                    variant="outlined"
                    onChange={handleChange}
                    style={{ marginBottom: 20, width: '100%', marginTop: 20 }}
                    size="small"
                    InputProps={{
                      className: classes.textarea,
                    }}
                  />

            </Widget>*/}
          </Grid>
          <Grid item xs={12} md={12} sm={12}>
              <Widget
                title="Custom Properties"
                upperTitle
                className={classes.card}
                bodyClass={classes.fullHeightBody}
                disableWidgetMenu
                showOverflow
              >
                  <CustomProperties customerProperties={newCustomer.custom_properties || null}
                                    enableCustomProperties={newCustomer.enable_custom_properties || false}
                                    onCustomerPropertiesChanged={onCustomerPropertiesChanged}
                                    onCustomPropertiesEnableChanged={onCustomPropertiesEnableChanged}/>
              </Widget>
          </Grid>
          <Grid item xs={12} md={12} sm={12}>
              <Widget
                title="Customer Pricing"
                upperTitle
                className={classes.card}
                bodyClass={classes.fullHeightBody}
                disableWidgetMenu
              >
                <div className={classes.pricingDisplay}>
                    <FormControl variant="outlined" className={classnames({
                          'chargeBySelect':  true,
                          'chargeby-select-control': true
                        })}>
                      <InputLabel>Charge By</InputLabel>
                      <div className={classnames({
                                    'chargeby-select-control-input': true
                                  })}>
                        <NativeSelect
                          value={selectedChargeBy}
                          onChange={handleChangeSelectChargeBy}
                        >
                           <option value="Tag">Tag</option>
                           <option value="Hour">Hour</option>
                        </NativeSelect>
                      </div>
                    </FormControl>
                    {selectedChargeBy === 'Hour' && <TextField
                      id="hourlyCharge"
                      label="Hourly Charge"
                      onChange={handleChange}
                      value={newCustomer.hourly_charge === undefined || newCustomer.hourly_charge === null || newCustomer.hourly_charge <= 0 ? hourly_charge : newCustomer.hourly_charge}
                      name="hourly_charge"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />}

                    <TextField
                      id="minCharge"
                      label="Min Charge"
                      onChange={handleChange}
                      value={newCustomer.min_charge}
                      name="min_charge"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="minCashCharge"
                      label="Min Cash Charge"
                      onChange={handleChange}
                      value={newCustomer.min_cash_charge}
                      name="min_cash_charge"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="localTravel"
                      label="Local Travel"
                      onChange={handleChange}
                      value={newCustomer.local_travel}
                      name="local_travel"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="seventyHundredTravel"
                      label="Travel 60 - 100km"
                      onChange={handleChange}
                      value={newCustomer.seventy_hundred_travel}
                      name="seventy_hundred_travel"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="over100Travel"
                      label="Region Travel > 100km"
                      onChange={handleChange}
                      value={newCustomer.over_100_travel}
                      name="over_100_travel"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />
                    {selectedChargeBy === 'Tag' && <><TextField
                      id="singlePhasePrice"
                      label="Single Phase Price"
                      onChange={handleChange}
                      value={newCustomer.single_phase_price}
                      name="single_phase_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />
                    <TextField
                      id="threePhasePrice"
                      label="Three Phase Price"
                      onChange={handleChange}
                      value={newCustomer.three_phase_price}
                      name="three_phase_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />
                    <TextField
                      id="rcdPrice"
                      label="RCD Price"
                      onChange={handleChange}
                      value={newCustomer.rcd_price}
                      name="rcd_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="firePrice"
                      label="Fire Price"
                      onChange={handleChange}
                      value={newCustomer.fire_price}
                      name="fire_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="fistAidPrice"
                      label="First Aid Price"
                      onChange={handleChange}
                      value={newCustomer.first_aid_price}
                      name="first_aid_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="medicalPrice"
                      label="Medical Price"
                      onChange={handleChange}
                      value={newCustomer.medical_price}
                      name="medical_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="rcdPbPrice"
                      label="RCD PB Price"
                      onChange={handleChange}
                      value={newCustomer.rcd_pb_price}
                      name="rcd_pb_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="lgPbPrice"
                      label="LG PB Price"
                      onChange={handleChange}
                      value={newCustomer.lg_pb_price}
                      name="lg_pb_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />


                    <TextField
                      id="lgMPrice"
                      label="LG6 Measured Price"
                      onChange={handleChange}
                      value={newCustomer.lg_m_price}
                      name="lg_m_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="threePhaseRcdPrice"
                      label="3 Phase RCD Price"
                      onChange={handleChange}
                      value={newCustomer.three_phase_rcd_price}
                      name="three_phase_rcd_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="microwavePrice"
                      label="Microwave Price"
                      onChange={handleChange}
                      value={newCustomer.microwave_price}
                      name="microwave_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="nonElectricalPrice"
                      label="Non Electrical Price"
                      onChange={handleChange}
                      value={newCustomer.non_electrical_price}
                      name="non_electrical_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="ladderPrice"
                      label="Ladder Price"
                      onChange={handleChange}
                      value={newCustomer.ladder_price}
                      name="ladder_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="aedPrice"
                      label="AED Price"
                      onChange={handleChange}
                      value={newCustomer.aed_price}
                      name="aed_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="evsePrice"
                      label="EVSE Price"
                      onChange={handleChange}
                      value={newCustomer.evse_price}
                      name="evse_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    /></>}
                </div>
              </Widget>
          </Grid>
        </Grid>

      </form>
    </div>
  );
//}
});
export default CreateCustomer;
